import { render, staticRenderFns } from "./NewRelationshipContact.vue?vue&type=template&id=a9340356"
import script from "./NewRelationshipContact.vue?vue&type=script&lang=js"
export * from "./NewRelationshipContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports